import { useState } from 'react';
import { BoError, login, type Session } from './api';
import { Signup } from './onboarding/Signup';
import { Alert, Button, Field, Input } from './ui';

/** Entrar na gestão, ou registar uma empresa (registo em 4 passos, docs/14 §3). */
export function AuthScreen({ onSession, notice }: { onSession: (s: Session) => void; notice?: string | null }) {
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const [f, setF] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (mode === 'signup') return <Signup onSession={onSession} onLogin={() => setMode('login')} />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSession(await login(f.email, f.password));
    } catch (err) {
      setError(err instanceof BoError ? err.message : 'Sem ligação à internet.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-full place-items-center bg-[var(--bg)] p-4">
      <form onSubmit={submit} className="surface w-full max-w-md space-y-5 rounded-2xl p-6 shadow-xs sm:p-8">
        <div className="flex items-center gap-3">
          <img src="/makila-simbolo.svg" alt="" className="h-11 w-11" />
          <div>
            <h1 className="font-display text-xl font-bold">Makila POS</h1>
            <p className="text-sm text-muted">Entrar na gestão</p>
          </div>
        </div>
        {notice && <Alert>{notice}</Alert>}
        <Field label="Email"><Input required autoFocus type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} autoComplete="email" /></Field>
        <Field label="Palavra-passe"><Input required type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} autoComplete="current-password" /></Field>
        {error && <Alert>{error}</Alert>}
        <Button disabled={busy} size="lg" className="w-full">{busy ? 'A entrar…' : 'Entrar'}</Button>
        <div className="border-t border-base pt-4 text-center text-sm">
          <span className="text-muted">Ainda não tem conta? </span>
          <button type="button" onClick={() => { setMode('signup'); setError(null); }} className="font-semibold text-brand-700 hover:underline">Registe a empresa</button>
        </div>
      </form>
    </div>
  );
}
